<template>
  <div class="container-progress mt-2">
    <div class="text-center step-title">
      {{ stepNames[currentStep] }}
    </div>
    <div class="progress-element mt-1">
      <div class="progress-ui">
        <div class="percent"></div>
      </div>
      <div class="steps" :class="lang === 'en' ? 'fix' : ''">
        <div class="step-container">
          <a class="progress-links" href="javascript:void(0)">
            <div class="step" :class="{ 'bg-primary text-white fw-bold border-primary': selectedPage === 'DistributionEditor', 'completed text-white': steps[0] && selectedPage !== 'DistributionEditor' }" id="0">
              <i class="fas fa-check" v-if="steps[0] === 'completed' && selectedPage !== 'DistributionEditor'"></i>
              <span class="number" v-else>1</span>
            </div>
          </a>
        </div>
        <div class="step-container">
          <a class="progress-links" href="javascript:void(0)">
            <div class="step" :class="{ 'bg-primary text-white fw-bold border-primary': selectedPage === 'DistributionSongs', 'completed text-white': steps[1] && selectedPage !== 'DistributionSongs' }" id="1">
              <i class="fas fa-check" v-if="steps[1] === 'completed' && selectedPage !== 'DistributionSongs'"></i>
              <span class="number" v-else>2</span>
            </div>
          </a>
        </div>
        <div class="step-container">
          <a class="progress-links" href="javascript:void(0)">
            <div class="step" :class="{ 'bg-primary text-white fw-bold border-primary': selectedPage === 'DistributionCover', 'completed text-white': steps[2] && selectedPage !== 'DistributionCover' }" id="2">
              <i class="fas fa-check" v-if="steps[2] === 'completed' && selectedPage !== 'DistributionCover'"></i>
              <span class="number" v-else>3</span>
            </div>
          </a>
        </div>
        <div class="step-container">
          <a class="progress-links" href="javascript:void(0)">
            <div class="step" :class="{ 'bg-primary text-white fw-bold border-primary': selectedPage === 'DistributionStores', 'completed text-white': steps[3] && selectedPage !== 'DistributionStores' }" id="3">
              <i class="fas fa-check" v-if="steps[3] === 'completed' && selectedPage !== 'DistributionStores'"></i>
              <span class="number" v-else>4</span>
            </div>
          </a>
        </div>
        <div class="step-container">
          <a class="progress-links" href="javascript:void(0)">
            <div class="step" :class="{ 'bg-primary text-white fw-bold border-primary': selectedPage === 'DistributionReview', 'completed text-white': steps[4] && selectedPage !== 'DistributionReview' }" id="4">
              <i class="fas fa-check" v-if="steps[4] === 'completed' && selectedPage !== 'DistributionReview'"></i>
              <span class="number" v-else>5</span>
            </div>
          </a>
        </div>
        <div class="step-container">
          <a class="progress-links" href="javascript:void(0)">
            <div class="step" :class="selectedPage === 'DistributionSent' ? 'active-page ' + steps[5] : steps[5]" id="5">
              <i class="fas fa-check" v-if="steps[5] === 'completed'"></i>
              <span class="number" v-else>6</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
export default {
  name: 'DistributionProgress',
  props: ['distribution'],
  data: function () {
    return {
      currentStep: 4,
      steps: ['', '', '', '', ''],
      stepNames: [
        this.$t('general_information'),
        this.$t('tracks'),
        this.$t('cover'),
        this.$t('stores'),
        this.$t('review')
      ],
      selectedPage: ''
    }
  },
  methods: {
    progress: function (stepNum) {
      let stepNumOr = stepNum
      stepNum = stepNum < 5 ? stepNum + 1 : stepNum
      let p = stepNum * 25
      document.getElementsByClassName('percent')[0].style.width = p >= 100 ? `100%` : `${p}%`
      this.steps.forEach((e, idx) => {
        if (idx === stepNumOr) {
          this.steps[idx] = ''
          this.steps[idx] = 'completed'
        }
        if (idx < stepNumOr) {
          this.steps[idx] = 'completed'
        }
        if (idx > stepNumOr) {
          this.steps[idx] = ''
        }
      })
      this.$forceUpdate()
    },
    validateDistro: function () {
      _.each(['release', 'songs', 'cover', 'stores', 'review'], (elem, idx) => {
        if (this.distribution.steps) {
          if (this.distribution.steps['step_' + elem] && this.distribution.steps['step_' + elem].validate) {
            this.progress(idx)
          }
        }
      })
    },
    getUrl: function (opt) {
      if (this.distribution._id) {
        let url = ''
        switch (opt) {
          case 'release':
            url = `/distributions/${this.distribution._id}`
            break
          case 'track':
            url = `/distributions/${this.distribution._id}/songs`
            break
          case 'cover':
            url = `/distributions/${this.distribution._id}/cover`
            break
          case 'store':
            url = `/distributions/${this.distribution._id}/stores`
            break
          case 'review':
            url = `/distributions/${this.distribution._id}/review`
            break
        }
        return url
      } else {
        return ''
      }
    }
  },
  created: function () {
    this.lang = this.$i18n.locale
    this.selectedPage = this.$parent.name

    if (this.selectedPage === 'DistributionEditor') {
      this.currentStep = 0
    } else if (this.selectedPage === 'DistributionSongs') {
      this.currentStep = 1
    } else if (this.selectedPage === 'DistributionCover') {
      this.currentStep = 2
    } else if (this.selectedPage === 'DistributionStores') {
      this.currentStep = 3
    } else if (this.selectedPage === 'DistributionReview') {
      this.currentStep = 4
    }
  },
  watch: {
    'distribution._id': function () {
      setTimeout(() => {
        this.validateDistro()
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped>
  .step-title {
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .container-progress {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 110px;
    margin-bottom: 5px;

    .border-primary {
      border-color: #5714ff !important;
    }

    .progress-element {
      width: 90%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .steps {
        position: relative;
        display: flex;
        justify-content: space-between;
        .step-container {
          width: 141px;
          text-align: center;
          .step {
            margin: 0 auto;
            margin-bottom: 10px;
            width: 30px;
            height: 30px;
            background: #fff;
            border: 2px solid #ACACA6;
            border-radius: 50%;
            transition: background 1s;
            text-align: center;
            &.completed {
              border: 2px solid #6ae36e !important;
              background: #6ae36e;
            }
            &.active-page {
              border-color: #212529;
              .number {
                color: #212529;
              }
            }
            i.fas.fa-check {
              // color: #fff;
              font-size: 18px;
              line-height: 26px;
            }
            .number {
              display: inline-block;
              font-size: 15px;
              // color: #ACACA6;
              // font-weight: 500;
              line-height: 25px;
            }
          }
          .progress-links {
            color: #ACACA6;

            .completed {
              color: white;
            }

            &:hover {
              text-decoration: none;
            }
            .active-page {
              color: #212529;
              font-weight: 600;
            }
          }
        }
      }
      .progress-ui {
        position: absolute;
        margin: 0 70px;
        width: calc(100% - 140px);
        height: 40%;
        border-bottom: 2px solid #ACACA6;
        z-index: -1;
        &.fix {
          height: 24%;
        }
        .percent {
          position: absolute;
          width: 0;
          height: 100%;
          border-bottom: 2px solid #6ae36e;
          z-index: 1;
          transition: width 1s;
          box-sizing: content-box;
        }
      }
    }
  }
  .show-mobile {
    display: none !important;
  }
  @media only screen and (max-width: 1024px) {
    .progress-element {
      .steps.fix {
        .step-container {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .show-mobile {
      display: block !important;
    }
    .hide-mobile {
      display: none !important;
    }

    .container-progress {
      .progress-element {
        width: 100%;
        .steps {
          .step-container {
            .step {
              width: 50px;
              height: 50px;
              i.fas.fa-check {
                font-size: 24px;
                line-height: 44px;
              }
              .number {
                font-size: 25px;
                line-height: 45px;
              }
            }
            .progress-links {
              .description-mobile {
                font-size: 14px;
              }
            }
          }
        }
        .progress-ui {
          height: 40%;
          &.fix {
            height: 34%;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 516px) {
    .container-progress {
      .progress-element {
        .steps {
          .step-container {
            .step {
              width: 40px;
              height: 40px;
              i.fas.fa-check {
                font-size: 19px;
                line-height: 38px;
              }
              .number {
                font-size: 20px;
                line-height: 36px;
              }
            }
            .progress-links {
              .description {
                font-size: 12px;
              }
            }
          }
        }
        .progress-ui {
          margin: 0 40px;
          width: calc(100% - 80px);
        }
      }
    }
  }
  @media only screen and (max-width: 414px) {
    .container-progress {
      .progress-element {
        .steps {
          .step-container {
            .step {
              i.fas.fa-check {
                font-size: 15px;
              }
              .number {
                font-size: 15px;
              }
            }
            .progress-links {
                .description-mobile {
                  font-size: 12px;
                }
              }
          }
        }
      }
    }
    @media only screen and (max-width: 375px) {
      .container-progress {
        .progress-element {
          .steps {
            .step-container {
              .progress-links {
                .description-mobile {
                  font-size: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/DistributionProgress.vue